import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { StyledTextArea } from './TextArea.style';
export const TextArea = React.forwardRef(({ name, readOnly = false, disabled = false, placeholder, defaultValue, value, resize = 'vertical', onChange, }, ref) => {
    return (_jsx(StyledTextArea, { ref: ref, name: name, readOnly: readOnly, disabled: disabled, placeholder: placeholder, defaultValue: defaultValue, value: value, resize: resize, onChange: onChange }));
});
TextArea.displayName = 'TextArea';
//# sourceMappingURL=TextArea.js.map